// extracted by mini-css-extract-plugin
export var danger = "_3d-6";
export var lightPink = "_3d-a";
export var medium = "_3d-j";
export var nearSquare = "_3d-m";
export var neutralBlue = "_3d-8";
export var neutralYellow = "_3d-7";
export var noCapitalize = "_3d-1";
export var normal = "_3d-2";
export var pill = "_3d-0";
export var primary = "_3d-3";
export var primaryLight = "_3d-4";
export var shadow = "_3d-n";
export var small = "_3d-k";
export var solidBlack = "_3d-i";
export var solidGreen = "_3d-d";
export var solidLightBlue = "_3d-f";
export var solidNavy = "_3d-e";
export var solidOrange = "_3d-h";
export var solidPink = "_3d-g";
export var solidRed = "_3d-b";
export var solidWhite = "_3d-9";
export var solidYellow = "_3d-c";
export var success = "_3d-5";
export var xsmall = "_3d-l";